import loadScriptOrStyle from "./loadScriptOrStyle.js";
export default function loadStyle(src, prefix, attrs) {
  return loadScriptOrStyle("style", src, prefix, attrs);
}
//# sourceMappingURL=loadStyle.js.map